import { ExemptionSource, ExemptionType } from 'common-src/models/PatientBillingExemption';

const defaultSelectableType = Object.values(ExemptionType).find((type) => type.isSelectable);

export const initialState = {
  exemptionType: defaultSelectableType?.value,
  startDate: null,
  endDate: null,
  source: ExemptionSource.UserInput.value,
};

export const UPDATABLE_FIELDS = ['endDate'];
